
import React from 'react';
import JumperElement from './jumperElement';
import { Route } from 'react-router-dom';


export default class TitleJumper extends React.Component{
    constructor(props){
        super(props)
    }

    render(){
        let elementJumper1=` <li className="toc-entry toc-h2 active" data-nav="1">
        <a href="#cdn">CDN</a>
</li>
<li className="toc-entry toc-h2 active" data-nav="1">
<a href="#npm">npm</a>
</li> <li className="toc-entry toc-h2 active" data-nav="1">
        <a href="#components">Components</a>
</li>
<li className="toc-entry toc-h2 active" data-nav="1">
<a href="#use">Usage</a>
</li>`
let elementJumper2=`     
<li className="toc-entry toc-h2" data-nav="2"><a href="#b-0">Examples</a></li>
<li className="toc-entry toc-h2" data-nav="2"><a href="#b-1">Simple calender</a></li>
<li className="toc-entry toc-h2" data-nav="2"><a href="#b-5">calender with 5 Row</a></li>
<li className="toc-entry toc-h2" data-nav="2"><a href="#b-2">Custom Style Calender</a></li>
<li className="toc-entry toc-h2" data-nav="2"><a href="#b-3">Transparent calender</a></li>
<li className="toc-entry toc-h2" data-nav="2"><a href="#b-8">Vertical calender</a></li>
<li className="toc-entry toc-h2" data-nav="2"><a href="#b-9">Full Calenders</a></li>
`
let elementJumper3=` <li className="toc-entry toc-h2" data-nav="3"><a href="#api-api">API</a></li>
<li className="toc-entry toc-h2" data-nav="3"><a href="#drawer-function">drawer</a></li>
<li className="toc-entry toc-h2" data-nav="3"><a href="#resizeDrawers-function">resizeDrawers</a></li>
<li className="toc-entry toc-h2" data-nav="3"><a href="#clearDrawer-function">clearDrawer</a></li>
<li className="toc-entry toc-h2" data-nav="3"><a href="#drawerShow-function">drawerShow</a></li>
`
let elementJumper4=`
<li className="toc-entry toc-h2" data-nav="4"><a href="#themes-themes">Themes</a></li>
<li className="toc-entry toc-h2" data-nav="4"><a href="#usage-themes">usage</a></li>
`
let elementJumper5=`      
<li className="toc-entry toc-h2" data-nav="5"><a href="#options-options">Options</a></li>
<li className="toc-entry toc-h2" data-nav="5"><a href="#usage-options">usage</a></li>
<li className="toc-entry toc-h2" data-nav="5"><a href="#class-objects">class objects</a></li>
`
        return(
            <div className="d-none d-xl-block col-xl-2 offset-xl-10 bd-toc">
      <ul className="section-nav" style={{listStyle:"none"}}>
      <Route path="/getting-start" exact render={()=><JumperElement codes={elementJumper1} key={1}></JumperElement>}/>
                <Route path="/example" render={()=><JumperElement codes={elementJumper2} key={2}></JumperElement>}/>
                
                <Route path="/api" render={()=><JumperElement codes={elementJumper3} key={3}></JumperElement>}/>
                
                <Route path="/themes" render={()=><JumperElement codes={elementJumper4} key={4}></JumperElement>}/>
                
                <Route path="/options" render={()=><JumperElement codes={elementJumper5} key={5}></JumperElement>}/>
        {/* <JumperElement codes={elementJumper1} key={1}></JumperElement> */}
        
        {/* <JumperElement codes={elementJumper2} key={2}></JumperElement>
        
        <JumperElement codes={elementJumper3} key={3}></JumperElement>
        
        <JumperElement codes={elementJumper4} key={4}></JumperElement>
        
        <JumperElement codes={elementJumper5} key={5}></JumperElement> */}
      </ul>
  </div>
                
        )
    }
}